export const message_unread_count = `subscription message_unread_count{
    message_unread_count
}`;
